// scheduling/services/obData.js
// Read service for over-budget reporting data

const OB_BASE = '/api/obData';

async function fetchOBData(type) {
  const url = `${OB_BASE}?type=${encodeURIComponent(type)}`;
  const r = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!r.ok) {
    const err = await r.text();
    throw new Error(`obData(${type}) ${r.status}: ${err}`);
  }
  return r.json();
}

export const fetchOverBudget = () => fetchOBData('population');
export const fetchOBConfig = () => fetchOBData('config');
